export default __webpack_public_path__ + "static/media/women-4.701e13ad.jpg";